/** @module Specification/BOM/SynchBOMFromThemeForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget"
], function(declare, lang, def, Field, Relationship, Widget) {

	var FIELD_COLORWAYS = "ColorColorways";
	var FIELD_UPDATE_PLACEMENT_ATTRIBUTES = "UpdatePlacementAttributes";
	var FIELD_INCLUDE_BLANKS = "IncludeBlankAttributes";

	return declare(Widget, {

		_resolveView: function() {
			var defView = this.defView;

			defView.addField(lang.mixin(new Field(), {
				m_label: FIELD_COLORWAYS,
				m_typeControl: def.FIELD_MULTI_SELECT,
				m_bRequired: false,
				widgetParams: {
					addItemAll: true
				},
				idParameter: FIELD_COLORWAYS
			}));

			defView.addField(lang.mixin(new Field(), {
				m_label: FIELD_UPDATE_PLACEMENT_ATTRIBUTES,
				m_typeControl: def.FIELD_CHECKBOX,
				idParameter: FIELD_UPDATE_PLACEMENT_ATTRIBUTES,
				bPersist: true
			}));

			defView.addField(lang.mixin(new Field(), {
				m_label: FIELD_INCLUDE_BLANKS,
				m_typeControl: def.FIELD_CHECKBOX,
				idParameter: FIELD_INCLUDE_BLANKS,
				bPersist: true
			}));

			this.inherited(arguments);
		},

		_buildView: function() {
			this.addDefaultValue(FIELD_COLORWAYS, this.EMPTY_COLORWAY_URL);
			var ac = this.getFormData().getSource();
			if (ac) {
				var cache = ac.getCache();
				var styleBomRevNode = cache.getNode(this.urlRoot);
				var styleBomNode = cache.getNode(styleBomRevNode.__Parent__);
				var styleNode = cache.getNode(styleBomNode.__Parent__);
				var themeNode = cache.getNode(styleNode.Theme);
				var themeURL = themeNode.$URL;

				this.defView.getField(FIELD_COLORWAYS).m_relationship = lang
					.mixin(new Relationship(), {
						m_url: themeURL,
						m_id: FIELD_COLORWAYS
					});
			}
			this.inherited(arguments);
		}

	});
});